import styled from 'styled-components';

import Button from '../../../../../../newComponents/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  margin-bottom: 25px;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #101d40;
  }

  p {
    color: #7c8db5;
    font-size: 14px;
  }

  @media only screen and (max-width: 768px) {
    text-align: center;
  }
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  background-color: #f7f7f7;
  border-radius: 5px;

  h4 {
    font-size: 16px;
    color: #101d40;
    font-weight: 600;
    margin-bottom: 3px;
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const OptionContent = styled.div`
  margin-left: 7px;

  span {
    color: #101d40;
    margin-bottom: 8px;
    font-size: 14px;
  }
`;

export const AddComplementsButton = styled(Button)`
  width: fit-content;
  margin-top: 20px;

  svg {
    margin-right: 5px;
    font-size: 16px;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const ComplementsList = styled.div`
  margin-top: 20px;
  border-radius: 5px;
  width: 100%;
  border: 2px solid #e6effb;
  font-family: 'Sora', sans-serif;
  transition: height 0.2s ease-out;
  overflow: hidden;
`;

export const ComplementsListHeader = styled.div`
  display: flex;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #e6effb;

  h2 {
    font-size: 20px;
    color: #101d40;
    font-weight: 600;
    letter-spacing: 0px;
  }
`;

export const ComplementsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;
